import React, { Component } from "react"
import * as dateHelper from "../../booking/helpers/date"
import { isMobile } from "react-device-detect"
import { DateTime } from "luxon"

export default class Flights extends Component {
  render() {
    if (this.props.flights && this.props.flights.length > 0) {
      const flights = this.props.flights.map((flight, index) => {
        const prevDate = index > 0 ? this.props.flights[index - 1].Date : ""
        const date = flight.Date
        const formattedDate = this.props.getFormattedDate(date, this.props.language)

        let dateHeader = ""
        if (index > 0) {
          if (prevDate !== date) {
            dateHeader = (
              <div className="stylish-table__row stylish-table__row--head">
                <div className="date flight-date-header" data-date={formattedDate}>
                  {formattedDate}
                </div>
              </div>
            )
          }
        } else {
          if (!isMobile) {
            let isFirstNewDate = false
            if (this.props.lastShownPreviousFlight) {
              const dtLocale = dateHelper.luxonLocale(this.props.language)
              const lastShownPreviousFlightDate = DateTime.fromFormat(this.props.lastShownPreviousFlight.Date, "dd-MM-yyyy").setLocale(dtLocale)
              const flightDate = DateTime.fromFormat(date, "dd-MM-yyyy").setLocale(dtLocale)
              isFirstNewDate = lastShownPreviousFlightDate.startOf("day").toMillis() !== flightDate.startOf("day").toMillis()
            }
            if (
              isFirstNewDate ||
              (index > 0 && (this.props.isPreviousFlights || (!this.props.isPreviousFlights && this.props.previousFlightsShown === 0)))
            ) {
              dateHeader = (
                <div className="stylish-table__row stylish-table__row--head">
                  <div className="date flight-date-header" data-date={formattedDate}>
                    {formattedDate}
                  </div>
                </div>
              )
            }
          }
        }

        return (
          <React.Fragment key={index}>
            {dateHeader}
            <a
              className="stylish-table__row stylish-table__row--body pointer flight-row"
              data-date={formattedDate}
              href={`${this.props.currentUrl}/${this.props.flightLandingPageExists ? `${flight.Iata}?id=${flight.FlightId}` : ""}`}
            >
              <div className="stylish-table__cell flights__table__col--time">
                <div>
                  {flight.Delayed ? (
                    <React.Fragment>
                      <span className="t--strike">{flight.Time}</span>
                      <span>
                        <em>{flight.ExpectedTime}</em>
                      </span>
                    </React.Fragment>
                  ) : (
                    <span>
                      <em>{flight.Time}</em>
                    </span>
                  )}
                </div>
              </div>
              <div className="stylish-table__cell flights__table__col--destination">
                <div>
                  <span className="v--desktop-only">
                    <strong>
                      <span>{flight.DestinationName}</span>
                    </strong>
                  </span>
                  <span className="v--mobile-only">
                    <strong>{flight.Destination}</strong> ({flight.IataDestination})
                  </span>
                  <span>
                    <small>{flight.Iata}</small>
                  </span>
                  <span className="v--mobile-only">{flight.AirlineMobile ? flight.AirlineMobile : flight.Airline}</span>
                </div>
              </div>
              <div className="stylish-table__cell flights__table__col--carrier v--desktop-only">
                <div>
                  <span>
                    <span>{flight.Airline}</span>
                  </span>
                </div>
              </div>
              <div className="stylish-table__cell  flights__table__col--link">
                <div>
                  {flight.Status ? <div className={`status ${flight.StatusClass}`}>{flight.Status}</div> : <div></div>}
                  <button className="infoarrow">{this.props.infoButtonLabel ?? "Info"}</button>
                </div>
              </div>
            </a>
          </React.Fragment>
        )
      })

      let newFlights = ""
      let oldFlights = ""
      let increaseAmount = this.props.increaseAmount
      const sizeDiff = this.props.allFlights.length - this.props.amountShown
      if (sizeDiff < 0) {
        increaseAmount = this.props.increaseAmount - Math.abs(sizeDiff)
      }
      if (this.props.isPreviousFlights) {
        const index = increaseAmount
        newFlights = flights.slice(0, index)
        oldFlights = flights.slice(index)
      } else {
        const index = flights.length - increaseAmount
        oldFlights = flights.slice(0, index)
        newFlights = flights.slice(index)
      }

      return (
        <React.Fragment>
          {this.props.isPreviousFlights ? "" : oldFlights}
          <div className={!this.props.isPreviousFlights && flights.length <= this.props.initialAmount ? "" : this.props.wrapperClass}>
            <div className="previous-flights-rotator">{newFlights}</div>
          </div>
          {this.props.isPreviousFlights ? oldFlights : ""}
        </React.Fragment>
      )
    }
    return ""
  }
}
